import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Section } from '@components/ui/Section.jsx';
import { BANGKOK } from '@/data/siteImagery.js';
import { OptimizedImage } from '@components/ui/OptimizedImage.jsx';

const TILES = [
  { ...BANGKOK.bangkokSkyline, label: 'Bangkok Skyline', span: 'lg:col-span-7 lg:row-span-2' },
  { src: '/assets/images/new-121.webp', alt: 'ISBM conference delegates in Bangkok', label: 'ISBM Delegates', span: 'lg:col-span-5' },
  { src: '/assets/images/new-122.webp', alt: 'Plenary session speaker at ISBM Bangkok 2025', label: 'Plenary Sessions', span: 'lg:col-span-5', imagePosition: 'center 20%' },
];

export function BangkokShowcase() {
  return (
    <Section className="border-t border-ink-200/50 dark:border-ink-800/50 bg-ink-950 text-white overflow-hidden">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y:   0 }}
        viewport={{ once: true, amount: 0.2 }}
        className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12"
      >
        <div>
          <p className="eyebrow text-accent-400 mb-3">Prestige</p>
          <h2 className="h-display text-3xl sm:text-4xl lg:text-5xl text-balance max-w-2xl">
            Experience ISBM 2026 in one of the world&apos;s most vibrant city.
          </h2>
        </div>
        <Link
          to="/venue"
          className="btn border border-white/30 text-white hover:bg-white/10 shrink-0 self-start lg:self-auto"
        >
          Venue &amp; Travel <ArrowUpRight size={16} />
        </Link>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-5 lg:auto-rows-[200px]">
        {TILES.map((tile, i) => (
          <motion.figure
            key={tile.src}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ delay: i * 0.08, duration: 0.6 }}
            className={`relative overflow-hidden rounded-3xl group ${tile.span}`}
          >
            <OptimizedImage
              src={tile.src}
              alt={tile.alt}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              style={tile.imagePosition ? { objectPosition: tile.imagePosition } : undefined}
              priority={i === 0}
              deferUntilVisible={i > 0}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink-950/90 via-ink-950/20 to-transparent" />
            <figcaption className="absolute bottom-0 left-0 right-0 p-5 sm:p-6">
              <span className="text-xs uppercase tracking-[0.2em] text-accent-400 font-semibold">
                Bangkok 2026
              </span>
              <p className="mt-1 font-display text-xl text-white">{tile.label}</p>
            </figcaption>
          </motion.figure>
        ))}


      </div>
    </Section>
  );
}
